const button = document.querySelector('.description .content button')
const containerElem = document.querySelector('.description')
const frame = containerElem?.querySelector('div')
const paragraphContainer = containerElem?.querySelector('.content')
let visibleContent = false

if (button != null && frame?.offsetHeight > 0 && paragraphContainer?.offsetHeight > 0) {

  if (paragraphContainer?.offsetHeight > frame?.offsetHeight) {
    button.style.visibility = 'visible'
  }

  button.addEventListener('click', () => {

    visibleContent = !visibleContent

    if (visibleContent) {
      containerElem?.classList.add('!h-full', '!overflow-visible')
      frame.classList?.add('!h-full')
      paragraphContainer?.classList.add('!h-full', '!overflow-visible', 'py-[55px]')
      button.innerHTML = 'Read less'
    } else {
      containerElem?.classList.remove('!h-full', '!overflow-visible')
      frame.classList?.remove('!h-full')
      paragraphContainer?.classList.remove('!h-full', '!overflow-visible', 'py-[55px]')
      button.innerHTML = 'Read more'
    }
  })
}